class OP3Dialog {
    /**
     * Default jquery-confirm options
     *
     * @return {object}
     */
    static get dialogOptions() {
        return {
            theme: 'optimizepress',
            useBootstrap: false,
            closeIcon: true,
            draggable: false,
            defaultButtons: {},
            smoothContent: false,
            closeIconClass: 'op3-iconFont op3-close-fill-icon'
        };
    }

    /**
     * HTML with input for filtering
     *
     * @param {string} confirmTitle
     * @return {string}
     */
    static headerWithFilter(confirmTitle) {
        return `
            <div class="d-flex justify-content-between align-items-center op3-form">
                <div>
                    <h4>${confirmTitle}</h4>
                </div>
                <div>
                    <input class="op3-input-filter" placeholder="Filter Integrations" type="text">
                </div>
            </div>
        `;
    }
}

export default OP3Dialog;


// WEBPACK FOOTER //
// ./resources/assets/js/General/Dialog.js